import {
  Outlet,
  createFileRoute,
  redirect,
  useNavigate,
  useRouter,
} from '@tanstack/react-router'
import { useCallback } from 'react'
import { BaseRedirectSearchSchema } from '@/schemas/page'
import ModalGuest from '@/components/make-booking/trip-details/ModalGuest'

export const Route = createFileRoute('/make-booking/$id/trip-details/signin')({
  validateSearch: BaseRedirectSearchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: search.redirect,
        ignoreBlocker: true,
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (params) => params.id,
  })
  const router = useRouter()
  const navigate = useNavigate()
  const onClose = useCallback(() => {
    if (router.history.canGoBack()) {
      return router.history.back({ ignoreBlocker: true })
    }
    return navigate({
      to: '/make-booking/$id/trip-details',
      params: { id: bookingId },
      replace: true,
    })
  }, [router, navigate])
  return (
    <>
      <ModalGuest opened bookingId={bookingId} onClose={onClose} />
      <Outlet />
    </>
  )
}
